import * as yup from "yup";
import { validationSchemas } from "./data";
export const productOptionSchema = yup.object().shape({
  productCategory: validationSchemas.name,
  productOptionName: validationSchemas.name,
  unit: validationSchemas.name,
  price: validationSchemas.number,
});
